import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {KeyValuePair} from '@/globals';
import {LocationModel} from '@/sdk';
import {SitesApi} from '@/sdk/api-services';
import {LocationApi} from '@/sdk/api-services/location.api';
import {Component} from 'vue-property-decorator';
import {LocationDcoumentationService} from '../services';
import {SiteLocationService} from '../services/site-location.service';

@Component({
    name: 'SaveDocumentationFileDialogComponent',
})
export default class SaveDocumentationFileDialogComponent extends VueWrapper {
    public readonly name: string = 'save-documentation-file';
    public locationDocumentationSrv: LocationDcoumentationService = new LocationDcoumentationService();

    public mounted() {
        //
    }

    public saveFile() {
        this.locationDocumentationSrv.SaveDocumantationFile();
    }
}
